var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAxly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z",
    fill: "url(#paint0_linear_3996_42588)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z",
    fill: "url(#paint1_radial_3996_42588)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8682 12.1376C46.803 15.6703 47.8981 19.7377 47.8981 24H42.6238L33.3167 7.88434L35.8981 3.28805V3.27851C35.8981 3.27851 35.9148 3.2298 35.9347 3.17313C39.6531 5.30853 42.7453 8.41109 44.8682 12.1376Z",
    fill: "url(#paint2_radial_3996_42588)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9395 44.8241L35.879 44.6483L33.3357 40.1252L33.3198 40.1125L42.6206 24H47.9999C47.9999 25.3441 47.8884 26.6692 47.6741 27.9643C46.4744 35.182 42.054 41.3108 35.9395 44.8241Z",
    fill: "url(#paint3_radial_3996_42588)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9394 44.8241C32.423 46.8446 28.3464 48 23.9999 48C19.5984 48 15.4737 46.8152 11.9272 44.747L14.6354 40.0361H14.6386L14.6895 40.122H33.3102L33.3198 40.1093L33.3357 40.122L35.8789 44.6451V44.6483L35.9394 44.8241Z",
    fill: "url(#paint4_radial_3996_42588)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8981 3.28807V3.27853L35.9363 3.17407C32.4206 1.15473 28.3451 0 23.9999 0C19.6689 0 15.6058 1.14724 12.0979 3.15442L12.1082 3.27534V3.28489L14.6769 7.87481H33.3166V7.88436L35.8981 3.28807Z",
    fill: "url(#paint5_radial_3996_42588)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43161 11.6259C5.54878 8.11427 8.53983 5.18896 12.1036 3.15109C12.1025 3.21557 12.1023 3.27216 12.105 3.27216H12.1082V3.28489L14.6769 7.87481H14.6865V7.878L5.37931 24L1.25826e-05 24C5.61479e-05 24.0002 -3.09988e-05 23.9998 1.25826e-05 24C0.00011214 19.7083 1.12659 15.6791 3.10013 12.1931C3.2088 12.003 3.31933 11.8138 3.43161 11.6259Z",
    fill: "url(#paint6_radial_3996_42588)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47637 34.6297C0.89613 31.3883 0 27.7632 0 24H5.37931L14.6387 40.0393H14.6355L11.9745 44.6419V44.6515C11.9745 44.6515 11.98 44.7111 11.9859 44.7811C7.901 42.4144 4.57836 38.8778 2.47637 34.6297Z",
    fill: "url(#paint7_radial_3996_42588)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24C25.0578 24.56 24.56 25.0578 24 38C23.3778 25.0578 22.9422 24.56 10 24C22.9422 23.3778 23.3778 22.9422 24 10C24.56 22.9422 25.0578 23.3778 38 24Z",
    fill: "url(#paint8_linear_3996_42588)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3996_42588",
    x1: 12.0037,
    y1: 47.999,
    x2: 2.91395,
    y2: 16.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16394,
    stopColor: "#FFB195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415935,
    stopColor: "#E15C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0654EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3996_42588",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24) rotate(90) scale(24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807291,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3996_42588",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4999 14) rotate(109.431) scale(24.9149 17.5313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#305DDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3996_42588",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4999 36.5) rotate(82.3039) scale(18.6682 13.1377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#305DDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3996_42588",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.8641 45.8097) rotate(143.826) scale(12.2048 14.2458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#305DDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3996_42588",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41 9.99999) rotate(-165.5) scale(29.9541 34.9262)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#305DDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3996_42588",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0001 18.5) rotate(104.931) scale(15.5242 10.9208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#305DDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3996_42588",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7 38) rotate(79.0459) scale(15.7877 11.1099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#305DDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3996_42588",
    x1: 51.2309,
    y1: -7.26138,
    x2: 34.5455,
    y2: 59.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxly);
export default __webpack_public_path__ + "static/media/AXLY.4b6e0d6cac63ff7364a5cf57646a293b.svg";
export { ForwardRef as ReactComponent };